module.exports = __webpack_public_path__ + "static/canada-flag-1712a10b4597a1c07b0288b134b03ce0.png";